import React from 'react';
import strings from 'localization/strings';
import { useScrollToTop } from 'helpers/BrowserHelper';

import PageTitle from 'common/PageTitle';
import Container from 'common/Container';
import Text from 'common/Text';

const IntegrityPolicyPage = () => {
    useScrollToTop();

    return (
        <Container withPageMargins>
            <PageTitle>{strings.integrityPolicy}</PageTitle>
            <Text component="div" html={strings.pages.integrityPolicy} ignoreNewlines />
        </Container>
    );
};

export default IntegrityPolicyPage;
